"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const ApplicationContext = (0, react_1.createContext)({
    sideMenu: undefined,
    sideMenuContext: undefined,
    bottomMenuContext: undefined,
    insidePageElement: undefined,
});
exports.default = ApplicationContext;
